import { animate, state, style, transition, trigger } from '@angular/animations';
import { E } from '@angular/cdk/keycodes';
import { AfterContentInit, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Parser } from 'expr-eval';
import * as _ from 'lodash';
import { isNaN } from 'lodash';
import { db } from 'src/app/db/db';
import { GPSPosition } from 'src/app/domain/GPS-position';
import { EchantillonnagePhyto } from 'src/app/domain/Lac - EAU/echantillonnage-phyto';
import { EBloomAlgal } from 'src/app/domain/Lac - EAU/enum/bloom-algal';
import { EEmplacementMesure } from 'src/app/domain/Lac - EAU/enum/emplacement-mesure';
import { EIntensiteVent } from 'src/app/domain/Lac - EAU/enum/intensite-vent';
import { ELacProcessTypes } from 'src/app/domain/Lac - EAU/enum/lac-process-types';
import { EMaterielEauIntegrePhyto } from 'src/app/domain/Lac - EAU/enum/materiel-eau-integre';
import { EMaterielEauPonctuel } from 'src/app/domain/Lac - EAU/enum/materiel-eau-ponctuel';
import { EMaterielSediment } from 'src/app/domain/Lac - EAU/enum/materiel-sediment';
import { EPresenceMarnage } from 'src/app/domain/Lac - EAU/enum/presence-marnage';
import { ESurfaceEau } from 'src/app/domain/Lac - EAU/enum/surface-eau';
import { LacProcess } from 'src/app/domain/Lac - EAU/lac-process';
import { MesurePhysique } from 'src/app/domain/Lac - EAU/mesure-physique';
import { PrelevementLac } from 'src/app/domain/Lac - EAU/prelevement-lac';
import { Secchi } from 'src/app/domain/Lac - EAU/secchi';
import { EMeteo } from 'src/app/domain/SANDRE/meteo';
import { EMasterSondeType } from 'src/app/domain/Shared/enum/master-sonde-type';
import { MasterSonde } from 'src/app/domain/Shared/master-sonde';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { LacService } from 'src/app/services/lac.service';
import { MasterSondeService } from 'src/app/services/master-sonde.service';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { LacMeasureBoxComponent } from 'src/app/tools/ui/lac-measure-dialog/lac-measure-box.component';
import { LacPhytoEchantComponent } from 'src/app/tools/ui/lac-phyto-echant-dialog/lac-phyto-echant-dialog.component';
import { LacPonctuelDialogomponent } from 'src/app/tools/ui/lac-ponctuel-dialog/lac-pontuel-dialog.component';
import { SecchiBoxComponent } from 'src/app/tools/ui/secchi-box/secchi-box.component';
import { StringConverter } from 'src/app/tools/ui/string-converter';

@Component({
    selector: 'app-lac',
    templateUrl: './lac.component.html',
    styleUrls: ['./lac.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class LacComponent implements OnInit, AfterContentInit {
    ELacProcessTypes = ELacProcessTypes;
    EEmplacementMesure = EEmplacementMesure;
    EPresenceMarnage = EPresenceMarnage;
    IsY2FarControl = new UntypedFormControl('', Validators.compose([
        Validators.pattern(/^(\d{7})?$/)]));

    IsX2FarControl = new UntypedFormControl('', Validators.compose([
        Validators.pattern(/^(\d{6})?$/)]));

    // MESURES PHYSICO
    Secchi1Control = new UntypedFormControl('', Validators.min(0));
    Secchi2Control = new UntypedFormControl('', Validators.min(0));
    Secchi3Control = new UntypedFormControl('', Validators.min(0));

    DistanceBergeControl = new UntypedFormControl('', Validators.min(0));
    FacteurCorrectionControl = new UntypedFormControl('', Validators.min(0));

    // DESC STATION
    AmplitudeMarnageControl = new UntypedFormControl('', Validators.min(0));
    HauteurVagueControl = new UntypedFormControl('', Validators.min(0));
    ProfondeurControl = new UntypedFormControl('', Validators.min(0));

    // EAU INTEGRE
    PlageProfondeurDebutControl = new UntypedFormControl('', Validators.compose([
        this.checkMinAgainstMaxEAUintegre(),
        Validators.min(0)]));
    PlageProfondeurFinControl = new UntypedFormControl('', Validators.compose([
        this.checkMaxAgainstMinEAUintegre(),
        Validators.min(0)]));
    NbFlaconControl = new UntypedFormControl('', Validators.min(0));
    TemperatureGlaciereControl = new UntypedFormControl('', Validators.min(0));

    // SEDIMENT
    SedimentPlageProfondeurControl = new UntypedFormControl('', Validators.min(0));
    EpaisseurControl = new UntypedFormControl('', Validators.min(0));
    SedimentNbFlaconControl = new UntypedFormControl('', Validators.min(0));
    SedimentTemperatureGlaciereControl = new UntypedFormControl('', Validators.min(0));

    // PHYTO
    VolumeFinalControl = new UntypedFormControl('', Validators.min(0));
    VolumeLugolQualitatifControl = new UntypedFormControl('', Validators.min(0));
    PhytoPlageProfondeurDebutControl = new UntypedFormControl('', Validators.compose([
        this.checkMinAgainstMaxPhyto(),
        Validators.min(0)]));
    PhytoPlageProfondeurFinControl = new UntypedFormControl('', Validators.compose([
        this.checkMaxAgainstMinPhyto(),
        Validators.min(0)]));
    VolumeLugolQuantitatifControl = new UntypedFormControl('', Validators.min(0));

    @ViewChild('chimieTable') chimieTable: MatTable<any>;
    displayedColumns: string[] = ['profondeur', 'o2', 'sato2', 'pH', 'conduc', 'tempBrute', 'tempCorrige'];
    @ViewChild('phytoTable') phytoTable: MatTable<any>;
    phytoDisplayedColumns: string[] = ['profondeur', 'volume'];
    public IntensiteVentList: string[] = Object.values(EIntensiteVent).filter(x => !isNaN(Number(x))).map(x => StringConverter.getIntensiteVent(x as EIntensiteVent));
    public SurfaceEauList: string[] = Object.values(ESurfaceEau).filter(x => !isNaN(Number(x))).map(x => StringConverter.getSurfaceEauName(x as ESurfaceEau));
    public MeteoList: string[] = Object.values(EMeteo).filter(x => !isNaN(Number(x))).map(x => StringConverter.getMeteoName(x as EMeteo));
    public BloomAlgalList: string[] = Object.values(EBloomAlgal).filter(x => !isNaN(Number(x))).map(x => StringConverter.getBloomAlgalName(x as EBloomAlgal));
    public PresenceMarnageList: string[] = Object.values(EPresenceMarnage).filter(x => !isNaN(Number(x))).map(x => StringConverter.getPresenceMarnageName(x as EPresenceMarnage));
    public EmplacementMesureList: string[] = Object.values(EEmplacementMesure).filter(x => !isNaN(Number(x))).map(x => StringConverter.getEmplacementMesureName(x as EEmplacementMesure));

    public MaterielEauIntegrePhytoList: string[] = Object.values(EMaterielEauIntegrePhyto).filter(x => !isNaN(Number(x))).map(x => StringConverter.getMaterielEauIntegrePhytoName(x as EMaterielEauIntegrePhyto));

    public MaterielSedimentList: string[] = Object.values(EMaterielSediment).filter(x => !isNaN(Number(x))).map(x => StringConverter.getMaterielSedimentName(x as EMaterielSediment));

    LacProcess: LacProcess = new LacProcess();

    SondeList: MasterSonde[] = [];

    UnknownFat: boolean = false;

    expandedElement: MesurePhysique | null;
    ModelGPS: GPSPosition = new GPSPosition();

    get SondePhList() {
        return this.SondeList.filter(x => x.Type === EMasterSondeType.PH);
    }
    get SondeOxygeneList() {
        return this.SondeList.filter(x => x.Type === EMasterSondeType.Oxygene);
    }
    get SondeConductiviteList() {
        return this.SondeList.filter(x => x.Type === EMasterSondeType.Conductivite);
    }

    constructor(
        private ChangeNavigationService: ChangeNavigationService,
        public coreData: CoreData,
        private route: ActivatedRoute,
        private router: Router,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private lacService: LacService,
        private masterSondeService: MasterSondeService) {
        this.ChangeNavigationService.NavigationUsedEmitter.subscribe(x => {
            if (x) {
                // this.update();
            }
        })
    }

    ngOnInit() {

    }

    async ngAfterContentInit(): Promise<void> {
        if (!this.route.snapshot.params.processCode) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        if (this.coreData.IsOffline) {
            this.SondeList = await db.getAllSondes();
            this.LacProcess = Object.assign(new LacProcess(), this.coreData.getOfflineProcess(this.route.snapshot.params.processCode));
            this.LacProcess.Code = this.route.snapshot.params.processCode;
        } else {
            this.LacProcess = await this.lacService.getLacProcessByCode(this.route.snapshot.params.processCode).toPromise();
            this.getAllSonde();
            this.UnknownFat = this.LacProcess.PrelSediment.Epaisseur === undefined || this.LacProcess.PrelSediment.Epaisseur === null;
        }

        this.retrieveGPSPosition();

        this.IsX2FarControl.markAsTouched();
        this.IsY2FarControl.markAllAsTouched();
    }

    retrieveGPSPosition() {
        this.ModelGPS.L93X = this.LacProcess.PhysiqueChimieInSitu.GPSPosition.L93X ?? this.LacProcess.PrelEauIntegre.GPSPosition.L93X ?? this.LacProcess.PrelPhyto.GPSPosition.L93X ?? this.LacProcess.PrelSediment.GPSPosition.L93X ?? this.LacProcess.PhysiqueChimieInSitu.GPSPosition.L93X;
        this.ModelGPS.L93Y = this.LacProcess.PhysiqueChimieInSitu.GPSPosition.L93Y ?? this.LacProcess.PrelEauIntegre.GPSPosition.L93Y ?? this.LacProcess.PrelPhyto.GPSPosition.L93Y ?? this.LacProcess.PrelSediment.GPSPosition.L93Y ?? this.LacProcess.PhysiqueChimieInSitu.GPSPosition.L93Y;
    }

    onKeyUpEventForGPSX(event: any) {
        this.LacProcess.PhysiqueChimieInSitu.GPSPosition.L93X = Number(event.target.value);
        this.LacProcess.PrelEauIntegre.GPSPosition.L93X = Number(event.target.value);
        this.LacProcess.PrelPhyto.GPSPosition.L93X = Number(event.target.value);
        this.LacProcess.PrelSediment.GPSPosition.L93X = Number(event.target.value);
        this.LacProcess.PhysiqueChimieInSitu.GPSPosition.L93X = Number(event.target.value);
        this.LacProcess.PrelEauPonctuelList.forEach(x => {
            x.GPSPosition.L93X = Number(event.target.value);
        });
    }

    onKeyUpEventForGPSY(event: any) {
        this.LacProcess.PhysiqueChimieInSitu.GPSPosition.L93Y = Number(event.target.value);
        this.LacProcess.PrelEauIntegre.GPSPosition.L93Y = Number(event.target.value);
        this.LacProcess.PrelPhyto.GPSPosition.L93Y = Number(event.target.value);
        this.LacProcess.PrelSediment.GPSPosition.L93Y = Number(event.target.value);
        this.LacProcess.PhysiqueChimieInSitu.GPSPosition.L93Y = Number(event.target.value);
        this.LacProcess.PrelEauPonctuelList.forEach(x => {
            x.GPSPosition.L93Y = Number(event.target.value);
        });
    }

    onMinAgainstMaxEAUintegre($event) {
        this.PlageProfondeurFinControl.updateValueAndValidity();
    }
    onMaxAgainstMinEAUintegre($event) {
        this.PlageProfondeurDebutControl.updateValueAndValidity();
    }
    onMinAgainstMaxPhyto($event) {
        this.PhytoPlageProfondeurFinControl.updateValueAndValidity();
    }
    onMaxAgainstMinPhyto($event) {
        this.PhytoPlageProfondeurDebutControl.updateValueAndValidity();
    }

    checkMinAgainstMaxEAUintegre(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.LacProcess && control.value < this.PlageProfondeurFinControl.value
                ? null : { wrongColor: control.value };
    }

    checkMaxAgainstMinEAUintegre(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.LacProcess && control.value > this.PlageProfondeurDebutControl.value
                ? null : { wrongColor: control.value };
    }

    checkMinAgainstMaxPhyto(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.LacProcess && control.value < this.PhytoPlageProfondeurFinControl.value
                ? null : { wrongColor: control.value };
    }

    checkMaxAgainstMinPhyto(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.LacProcess && control.value > this.PhytoPlageProfondeurDebutControl.value
                ? null : { wrongColor: control.value };
    }

    getPonctuelMaterielName(mat: EMaterielEauPonctuel) {
        return StringConverter.getMaterielEauPonctuelName(mat);
    }

    knownEpaisseur() {

        if (this.UnknownFat) {
            this.LacProcess.PrelSediment.Epaisseur = null;
        }
    }

    computeMoy() {

        return _.sumBy(this.LacProcess.PhysiqueChimieInSitu.SecchiList.map(x => x.Disparition + (x.Reapparition ?? 0)))
            / (this.LacProcess.PhysiqueChimieInSitu.SecchiList.filter(s => s.Disparition).length
                + this.LacProcess.PhysiqueChimieInSitu.SecchiList.filter(s => s.Reapparition > 0).length) / 100;
    }

    computeZeup() {
        return this.computeMoy() * 2.5;
    }

    registerSondePh(event: MatSelectChange) {
        this.coreData.setLastSondePhRef(event.value);
    }

    registerSondeOxy(event: MatSelectChange) {
        this.coreData.setLastSondeOxyRef(event.value);
    }

    registerSondeCond(event: MatSelectChange) {
        this.coreData.setLastSondeCondRef(event.value);
    }

    computeTemperatureFormula(tempBrute: number) {
        if (!this.SondeList || this.SondeList.length === 0 || !tempBrute) {
            return;
        }
        let formula: string = '';
        if (this.LacProcess.PhysiqueChimieInSitu.Sonde.SondePh)
            formula = _.first(this.SondeList.filter(x => x.Reference === this.LacProcess.PhysiqueChimieInSitu.Sonde.SondePh)).FacteurCorrection;
        else if (this.LacProcess.PhysiqueChimieInSitu.Sonde.SondeConductivite)
            formula = _.first(this.SondeList.filter(x => x.Reference === this.LacProcess.PhysiqueChimieInSitu.Sonde.SondeConductivite)).FacteurCorrection;
        else if (this.LacProcess.PhysiqueChimieInSitu.Sonde.SondeOxygene)
            formula = _.first(this.SondeList.filter(x => x.Reference === this.LacProcess.PhysiqueChimieInSitu.Sonde.SondeOxygene)).FacteurCorrection;

        var expression = Parser.parse(formula);
        var result = expression.evaluate({ x: tempBrute });
        return result;
    }

    addMesurePhysique(measure?: MesurePhysique) {
        // this.LacProcess.PhysiqueChimieInSitu.MesurePhysiqueList.push(...new Array<MesurePhysique>(this.NewMesureCount).fill(new MesurePhysique()));
        // this.NewMesureCount = 0;

        const dialogRef = this.dialog.open(LacMeasureBoxComponent, {
            data: { measure: measure, types: this.LacProcess.Types },
            width: '555px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: MesurePhysique) => {
            if (result) {
                if (result.IsForEauIntegre && this.LacProcess.PhysiqueChimieInSitu.MesurePhysiqueList.find(x => x.IsForEauIntegre)) {
                    NotificationManager.handleWarning('Une seule mesure autorisée pour un prélèvement d\'eau integré', this.snackBar);
                    return;
                }

                if (result.TemperatureBrute)
                    result.TemperatureCorrigee = this.computeTemperatureFormula(result.TemperatureBrute);
                this.LacProcess.PhysiqueChimieInSitu.MesurePhysiqueList.push(result);
                this.chimieTable.renderRows();
            }
        });
    }

    openMesureSecchi(measure?: Secchi) {

        if (this.LacProcess.PhysiqueChimieInSitu.SecchiList.length >= 4) {
            NotificationManager.handleWarning('4 mesures Secchi maximum', this.snackBar);
            return;
        }

        const dialogRef = this.dialog.open(SecchiBoxComponent, {
            data: measure ?? new Secchi(),
            width: '555px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: Secchi) => {
            if (result) {
                if (measure)
                    measure = result;
                else
                    this.LacProcess.PhysiqueChimieInSitu.SecchiList.push(result);
            }
        });
    }

    removeSecchi(measure: Secchi) {
        _.remove(this.LacProcess.PhysiqueChimieInSitu.SecchiList, x => x === measure);
    }

    addEchantillonage(measure?: EchantillonnagePhyto) {
        const dialogRef = this.dialog.open(LacPhytoEchantComponent, {
            data: measure,
            width: '555px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.LacProcess.PrelPhyto.EchantillonnagePhytoList.push(result);
                this.phytoTable.renderRows();
            }
        });
    }

    recordPonctuel(measure?: PrelevementLac) {
        const dialogRef = this.dialog.open(LacPonctuelDialogomponent, {
            data: measure,
            width: '555px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.LacProcess.PrelEauPonctuelList[this.LacProcess.PrelEauPonctuelList.findIndex(x => x.SampleCode === measure.SampleCode)] = result;
            }
        });
    }

    getAllSonde() {
        this.masterSondeService.getAllSonde().subscribe(x => {
            this.SondeList = x;
            // this.LacProcess.PhysiqueChimieInSitu.Sonde.SondeConductivite = this.coreData.getLastSondeCondRef() ?? _.first(this.SondeConductiviteList)?.Reference;
            // this.LacProcess.PhysiqueChimieInSitu.Sonde.SondeOxygene = this.coreData.getLastSondeOxyRef() ?? _.first(this.SondeOxygeneList)?.Reference;
            // this.LacProcess.PhysiqueChimieInSitu.Sonde.SondePh = this.coreData.getLastSondePhRef() ?? _.first(this.SondePhList)?.Reference;
        });
    }

    update() {
        if (this.coreData.IsOffline) {
            this.coreData.setOfflineProcess(this.LacProcess);
            NotificationManager.handleSuccess('Prestation enregistrée', this.snackBar);
        } else {
            this.lacService.updateLacProcess(this.LacProcess).subscribe(x => {
                if (x) {
                    NotificationManager.handleSuccess('Prestation enregistrée', this.snackBar);
                }
            });
        }
    }

    deleteMesure(index: number) {
        _.remove(this.LacProcess.PhysiqueChimieInSitu.MesurePhysiqueList, this.LacProcess.PhysiqueChimieInSitu.MesurePhysiqueList[index]);
        this.chimieTable.renderRows();
    }
}
